import { useMemo } from "react";

const COLORS = ["#F7B731", "#089981", "#2962FF", "#FFFFFF"];

/** Lightweight CSS confetti burst — self-contained keyframes. */
const Confetti = ({ count = 42 }) => {
  const bits = useMemo(() => Array.from({ length: count }, (_, i) => ({
    left: Math.random() * 100,
    delay: Math.random() * 0.6,
    dur: 1.6 + Math.random() * 1.4,
    size: 5 + Math.random() * 6,
    color: COLORS[i % COLORS.length],
    spin: Math.random() > 0.5 ? 1 : -1,
  })), [count]);
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden">
      <style>{`@keyframes arc-confetti {0%{transform:translateY(0) rotate(0)}100%{transform:translateY(320px) rotate(var(--spin,540deg));opacity:.15}}`}</style>
      {bits.map((b, i) => (
        <span key={i} style={{
          position: "absolute", top: "-12px", left: `${b.left}%`, width: b.size, height: b.size * 0.45,
          background: b.color, borderRadius: 1,
          animation: `arc-confetti ${b.dur}s cubic-bezier(.3,.6,.6,1) ${b.delay}s forwards`,
          "--spin": `${b.spin * 720}deg`,
        }} />
      ))}
    </div>
  );
};

export default Confetti;
